// In-memory only. A full page load creates a new module instance, so the
// alert shows again. Client-side navigations keep this module alive.
const dismissedAgencyIDs = new Set();

export const dismissAgencyLinkingPromptForSession = ({ agencyID } = {}) => {
  if (!agencyID) return false;
  dismissedAgencyIDs.add(agencyID);
  return true;
};

export const isAgencyLinkingPromptDismissedForSession = ({ agencyID } = {}) =>
  Boolean(agencyID) && dismissedAgencyIDs.has(agencyID);

export const resetAgencyLinkingPromptSessionForTests = () => {
  dismissedAgencyIDs.clear();
};
